var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const captureImage = (viewer, type, quality) => {
    // For Chrome (which uses the Blink engine), the default quality parameters are:
    // - JPEG (image/jpeg): 0.92 (92%)
    // - WebP (image/webp): 0.80 (80%)
    // Raise WebP defaults as image is being compressed significantly out-of-the-box
    if (quality === undefined && type === 'image/webp') {
        quality = 0.92;
    }
    const canvas = viewer.canvasRef.current;
    return new Promise(resolve => {
        canvas.toBlob(resolve, type, quality);
    });
};
const toExtension = (type) => {
    switch (type) {
        case 'image/webp':
            return 'webp';
        case 'image/jpeg':
            return 'jpeg';
        default:
            return 'png';
    }
};
export const downloadImage = (viewer, type) => __awaiter(void 0, void 0, void 0, function* () {
    const blob = yield captureImage(viewer, type);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `screenshot.${toExtension(type)}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
});
